var Mapper;
(function (Mapper) {
    Mapper["COMPONENT_MAPPING"] = "ComponentMapping";
    Mapper["MAP_TO"] = "MapTo";
})(Mapper || (Mapper = {}));

export { Mapper };
//# sourceMappingURL=enum.js.map
